module.exports = __webpack_public_path__ + "static/media/link.c65a683c.svg";